import { inject } from 'vue'

export default function () {
  const ksToast = <Toast>inject('ksToast')

  return {
    ksToast
  }
}
